import React, { useRef, useState, useContext, useEffect } from "react";
import MessageAlert from "../../../components/messageAlert";
import Loader from "../../../components/loader";
import axios from "axios";
import buildLink from "../../../urls";
import { PlaySounds } from "../../../functions/playSounds";
import { CompanyContext } from "../../../contexts/companyCotext";
import useDeviceSize from "../../../components/useDeviceSize";
import {
  FaAngleDown,
  FaArrowAltCircleDown,
  FaArrowLeft,
  FaEye,
  FaSearch,
  FaTrash,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { GoQuestion } from "react-icons/go";
import "swiper/css";
import "swiper/css/pagination";
import PointsLoader from "../../../components/PointsLoader";
import { axiosServer } from "../../../axiosServer";

const WarehouseProduct = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();

  const history = useNavigate();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [WahrehouesInfo, setWahrehouesInfo] = useState([]);
  const [jardehInfo, setJardehInfo] = useState([]);
  const [error, setError] = useState(null);
  const productId = useRef(null);
  const slaves = useRef(null);
  const [systemQuantity, setSystemQuantity] = useState(null);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [productInf, setProductInf] = useState(null);
  const [loading, setLoading] = useState(false);
  const [keyboardType, setKeyboardType] = useState("text");
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const menuRefButton = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedSku, setSelectedSku] = useState("");
  const [width] = useDeviceSize();

  const getProducts = async (e) => {
    setProductInf(null);
    e.preventDefault();
    setLoadingSearch(true);
    setLoading(true);
    setError(null);
    try {
      const url =
        buildLink(`getproductsinwarehouse`) +
        `&product_id=${productId.current.value}`;
      const response = await axiosServer.get(url);
      if (response.data.success) {
        setWahrehouesInfo(response.data.warehouses);
        setJardehInfo(response?.data?.jardeh);
        setSystemQuantity(response.data.system_quantity);
        playSuccessSound();
        setMessage(response.data.message);
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        playErrorSound();
        setMessage(response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);

        setWahrehouesInfo([]);
      }
    } catch (e) {
      playErrorSound();
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      setLoadingSearch(false);
      setLoading(false);
    } finally {
      setLoadingSearch(false);
      setLoading(false);
    }
  };

  const searchProduct = async (e) => {
    setProductInf(null);
    e.preventDefault();
    setLoading(true);
    if (productId.current) {
      productId.current.blur();
    }
    const item = productId.current.value;
    try {
      const url =
        buildLink("productInfo") +
        `&item=${item}&v2=true` +
        `&user_id=${stateCom.userID}`;
      await axiosServer.get(url).then((response) => {
        setKeyboardType("none");
        if (response.data.success) {
          setLoading(false);

          setProductInf(response.data.data);
        } else {
          setLoading(false);
        }
      });
    } catch (e) {
      setLoading(false);
    }
  };

  function sanitizeHTML(html) {
    if (typeof window !== "undefined") {
      return DOMPurify.sanitize(html);
    } else {
      return html;
    }
  }

  const handleTrashClick = () => {
    productId.current.value = "";
    productId.current.focus();
  };

  function unescapeHTML(str) {
    if (!str) {
      return;
    }
    return str.replace(/\&([^;]+);/g, function (entity, entityCode) {
      var match;

      if (entityCode in htmlEntities) {
        return htmlEntities[entityCode];
        /*eslint no-cond-assign: 0*/
      } else if ((match = entityCode.match(/^#x([\da-fA-F]+)$/))) {
        return String.fromCharCode(parseInt(match[1], 16));
        /*eslint no-cond-assign: 0*/
      } else if ((match = entityCode.match(/^#(\d+)$/))) {
        return String.fromCharCode(~~match[1]);
      } else {
        return entity;
      }
    });
  }
  var htmlEntities = {
    nbsp: " ",
    cent: "¢",
    pound: "£",
    yen: "¥",
    euro: "€",
    copy: "©",
    reg: "®",
    lt: "<",
    gt: ">",
    quot: '"',
    amp: "&",
    apos: "'",
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    productId.current.focus();
  }, []);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function scrollToExistingHeader() {
    const orderHistoryElement = document.getElementById("order-history");
    const dataEntryHistoryElement =
      document.getElementById("data-entry-history");
    const returnOrderHistoryElement = document.getElementById(
      "return-order-history",
    );

    if (orderHistoryElement) {
      orderHistoryElement.scrollIntoView({ behavior: "smooth" });
    } else if (dataEntryHistoryElement) {
      dataEntryHistoryElement.scrollIntoView({ behavior: "smooth" });
    } else if (returnOrderHistoryElement) {
      returnOrderHistoryElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  const handleButtonClick = () => {
    setShowTooltip(!showTooltip);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const handleOpenPopup = (orderId) => {
    setPopupData(orderId);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPopupData(null);
  };
  var host = window.location.host;

  const onSubmit = (event) => {
    getProducts(event);
    searchProduct(event);
  };

  return (
    <>
      {/* Header */}
      <div className="mb-5 sticky top-0 flex flex-col bg-white z-50">
        <div className="w-full bg-dbase h-16">
          <div className="container px-3 relative flex justify-between w-full text-white h-full">
            <div className="flex gap-7 flex-row justify-start">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className="text-xl my-auto">Products</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <form onSubmit={onSubmit}>
          <div className="flex flex-col">
            <div className="mb-1">Product ID or SKU</div>
            <div className="flex flex-row border-dblack rounded-lg text-center w-full gap-3">
              <div className=" relative flex flex-row border-dblack rounded-lg text-center w-full gap-3">
                <input
                  ref={productId}
                  type="text"
                  className="border border-dblack rounded-lg block p-2 flex-grow text-start w-full h-12 pr-10" // Add pr-10 to create space for the icon
                  placeholder="Product ID or SKU"
                />
                <FaTrash
                  onClick={() => handleTrashClick()}
                  className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                />
              </div>

              <button className="border border-dblack bg-dbase rounded-lg text-white px-5 h-12">
                {loadingSearch ? <Loader /> : <FaSearch />}
              </button>
            </div>
          </div>
        </form>
      </div>

      {loading ? (
        <PointsLoader />
      ) : (
        <div className="container ">
          {productInf && (
            <div className=" h-full flex flex-col justify-center text-center gap-2">
              <div
                className={`flex px-1 py-1 flex-row my-2 container ${width > 650 ? "justify-evenly" : "justify-start"} w-full`}
              >
                <div
                  className={` overflow-hidden h-54 w-48 my-auto ${
                    width > 650 ? " h-auto" : ""
                  }`}
                  style={{ width: width < 650 ? "50%" : "20%", height: "20%" }}
                >
                  {productInf.images && productInf.images.length > 0 ? (
                    <Swiper
                      pagination={true}
                      modules={[Pagination]}
                      className="mySwiper"
                    >
                      {productInf.images.map((image, index) => (
                        <SwiperSlide key={index}>
                          <img
                            className="relative cursor-pointer border border-slate200 px-1 py-1 w-full h-full"
                            src={image}
                            alt={`Image ${index}`}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <img
                      className="object-cover w-full h-full"
                      src={productInf.image}
                    />
                  )}
                </div>
                {width > 650 && (
                  <div className="flex  ">
                    <table className="w-auto border border-gray-300 border-collapse text-lg">
                      <tbody>
                        {productInf.status && (
                          <tr>
                            <th className="border px-3 py-2 text-left font-semibold bg-dgrey">
                              Status
                            </th>
                            <td
                              className={` px-8 py-2 text-center ${
                                productInf.status === "0"
                                  ? "text-dhotPink"
                                  : "text-dgreen"
                              }`}
                            >
                              {productInf.status === "0"
                                ? "Disabled"
                                : "Enabled"}
                            </td>
                          </tr>
                        )}

                        <tr>
                          <th className="border px-3 py-2 text-left font-semibold bg-dgrey">
                            Type
                          </th>
                          <td className="border px-3 py-2 text-center ">
                            {productInf.entity_type}
                          </td>
                        </tr>

                        <tr>
                          <th className="border px-3 py-2 text-left font-semibold bg-dgrey">
                            Search
                          </th>
                          <td className="border px-3 py-2 text-center ">
                            {productInf.matched_column}
                          </td>
                        </tr>

                        <tr>
                          <th className="border px-3 py-2 text-left font-semibold bg-dgrey">
                            Stand Qty
                          </th>
                          <td
                            className={` px-3 py-2 text-centers  ${
                              productInf.in_stand_quantity < 5
                                ? "text-dyellow"
                                : "text-dgreen"
                            }`}
                          >
                            {productInf.in_stand_quantity}
                          </td>
                        </tr>
                        <tr>
                          <th className="border px-3 py-2 text-left font-semibold bg-dgrey">
                            Address
                          </th>
                          <td className="border">
                            {WahrehouesInfo.find(
                              (w) => w.warehouse_name === "Main",
                            )?.address_id ?? "_"}
                          </td>
                        </tr>
                        {host === "pda.ishtari.com" && (
                          <tr>
                            <th className="border px-3 py-2 text-left font-semibold bg-dgrey">
                              On The Way
                            </th>
                            <td className="border px-3 py-2 text-center ">
                              {productInf?.on_the_way}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
                {width < 650 && (
                  <div className="w-auto ">
                    <table className="w-auto border border-dgrey1 border-collapse text-sm">
                      <tbody>
                        {productInf.status && (
                          <tr>
                            <th className="border border-dgrey1 px-3 py-2 text-left font-semibold bg-dgrey">
                              Status
                            </th>
                            <td
                              className={` border-dgrey1 px-3 py-2 text-start ${
                                productInf.status === "0"
                                  ? "text-dhotPink"
                                  : "text-dgreen"
                              }`}
                            >
                              {productInf.status === "0"
                                ? "Disabled"
                                : "Enabled"}
                            </td>
                          </tr>
                        )}

                        <tr>
                          <th className="border border-dgrey1 px-3 py-2 text-left font-semibold bg-dgrey">
                            Type
                          </th>
                          <td className="border px-3 py-2 text-start  ">
                            {productInf.entity_type}
                          </td>
                        </tr>

                        <tr>
                          <th className="border px-3 py-2 text-left font-semibold border-dgrey1 bg-dgrey">
                            Search
                          </th>
                          <td className="border px-3 py-2 text-start  ">
                            {productInf.matched_column}
                          </td>
                        </tr>

                        <tr>
                          <th className="border-r border-dgrey1 px-2 py-2 text-left font-semibold bg-dgrey">
                            <div className="flex items-center gap-1">
                              <span>StandQty</span>
                              <button
                                data-ripple-light="true"
                                data-tooltip-target="tooltip"
                                onClick={handleButtonClick}
                                className="flex items-center"
                              >
                                <GoQuestion />
                              </button>
                            </div>
                          </th>

                          <td
                            className={` border-dgrey1 px-3 py-2 text-start  ${
                              productInf.in_stand_quantity < 5
                                ? "text-dyellow"
                                : "text-dgreen"
                            }`}
                          >
                            {productInf.in_stand_quantity}
                          </td>
                        </tr>
                        <tr>
                          <th className="border border-dgrey1 px-3 py-2 text-left font-semibold bg-dgrey">
                            Address
                          </th>
                          <td className="border text-start px-3 py-2 ">
                            {WahrehouesInfo.find(
                              (w) => w.warehouse_name === "Main",
                            )?.address_id ?? "_"}
                          </td>
                        </tr>

                        {host === "pda.ishtari.com" && (
                          <tr>
                            <th className="border border-dgrey1 px-3 py-2 text-left font-semibold bg-dgrey">
                              On The Way
                            </th>
                            <td className="border text-start px-3 py-2 ">
                              {productInf?.on_the_way}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {showTooltip && (
                <div
                  data-tooltip="tooltip"
                  className="relative  text-sm   z-20 right-0 whitespace-normal break-words bg-black  text-white bg-dbase1"
                >
                  {productInf.in_stand_equation}
                </div>
              )}

              {productInf.slaves != "" && (
                <div className="mt-3 flex">
                  <h2 className="text-xl text-start font-semibold mb-4 text-dbase1">
                    Slaves Products
                  </h2>

                  <button
                    onClick={() => {
                      slaves.current?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="ml-auto justify-end"
                  >
                    <FaAngleDown size={20} />
                  </button>
                </div>
              )}

              {productInf.product_description != "none" && (
                <div>
                  <h2 className="text-lg font-bold mb-1  text-dbase1 text-left">
                    Description
                  </h2>

                  <div
                    className="  p-2 border text-left max-h-56 overflow-y-auto  relative"
                    dangerouslySetInnerHTML={{
                      __html: unescapeHTML(
                        sanitizeHTML(productInf?.product_description),
                      ),
                    }}
                  ></div>
                </div>
              )}
              <div>
                <h2 className="text-lg font-bold mb-1 text-dbase1 text-left">
                  Product
                </h2>
                <div className="overflow-x-auto max-w-full">
                  <table className="w-full border-collapse border">
                    <thead className="bg-dgrey">
                      <tr className="bg-gray-100 border-b">
                        <th className="p-4 border-r">ID</th>
                        <th className="p-4 border-r">SKU</th>
                        <th className="p-4 border-r">Model</th>
                        <th className="p-4 border-r">Price</th>
                        <th className="p-4 border-r">Barcode</th>
                        {/* <th className="p-4 border-r">Big Upc</th> */}
                        <th className="p-4 border-r">Online Qty</th>
                        <th className="p-4 border-r">System Quantity</th>
                        <th className="p-4 border-r">Fake Qty</th>
                        <th className="p-4 border-r">Rec Qty</th>
                        {productInf.entity_type === "Option" && (
                          <th className="p-4">{productInf.option_name}</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b">
                        <td className="p-4 border-r">
                          {productInf.entity_id === ""
                            ? "_"
                            : productInf.entity_id}
                        </td>
                        <td className="p-4 border-r">
                          {productInf.sku === "" ? "_" : productInf.sku}
                        </td>
                        <td className="p-4 border-r">
                          {productInf.model === "" ? "_" : productInf.model}
                        </td>
                        <td className="p-4 border-r">
                          {productInf.special === "" ? "_" : productInf.special}
                        </td>
                        <td className="p-4 border-r">
                          {productInf.barcode === "" ? "_" : productInf.barcode}
                        </td>
                        {/* <td className="p-4 border-r">
                          {productInf.big_upc === "" ? "_" : productInf.big_upc}
                        </td> */}
                        <td className="p-4 border-r">
                          {productInf.entity_type === "Option"
                            ? productInf.option_quantity
                            : productInf.quantity === ""
                              ? "_"
                              : productInf.quantity}
                        </td>
                        <td className="p-4 border-r"> {systemQuantity}</td>
                        <td className="p-4 border-r">
                          {productInf.fake_quantity === ""
                            ? "_"
                            : productInf.fake_quantity}
                        </td>
                        <td className="p-4 border-r">
                          {productInf.received_quantity === ""
                            ? "_"
                            : productInf.received_quantity}
                        </td>
                        {productInf.entity_type === "Option" && (
                          <td className="p-4">
                            {productInf.option_value_name}
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {WahrehouesInfo.length > 0 && (
                <div>
                  <h2 className="text-lg font-bold mb-1 text-dbase1 text-left">
                    Product In Warehouses
                  </h2>
                  <div className="overflow-x-auto max-w-full">
                    <table className="w-full border-collapse border overflow-scroll">
                      <thead>
                        <tr className="bg-dgrey text-dblackk">
                          <th className="border px-4 py-2">Warehouse Name</th>
                          <th className="border px-4 py-2">Quantity</th>
                          <th className="border px-4 py-2">Address</th>
                          <th className="border px-4 py-2">Reference</th>
                          <th className="border px-4 py-2">Pending Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {WahrehouesInfo.map((warehouse, index) => (
                          <tr key={index} className="hover:bg-gray-100">
                            <td className="border px-4 py-2 text-center">
                              {warehouse.warehouse_name}
                            </td>
                            <td className="border px-4 py-2 text-center">
                              {warehouse.quantity}
                            </td>
                            <td className="border px-4 py-2 text-center">
                              {warehouse.address_id}
                            </td>
                            <td className="border px-4 py-2 text-center">
                              {warehouse.reference}
                            </td>
                            <td className="border px-4 py-2 text-center">
                              {warehouse.pending_qty}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {productInf.all_options.length > 0 && (
                <div>
                  <h2 className="text-lg font-bold text-dbase1 text-left mb-1 mt-4">
                    Other Options:
                  </h2>
                  <table className="table-auto w-full rounded-md border">
                    <thead className="bg-dgrey">
                      <tr>
                        <th className="border text-center  px-2 py-2 whitespace-pre-wrap">
                          ID
                        </th>
                        <th className="border text-center  px-2 py-2 whitespace-pre-wrap">
                          {productInf.all_options[0].name}
                        </th>
                        <th className="border text-center  px-2 py-2 whitespace-pre-wrap">
                          QTY
                        </th>
                        <th className="border text-center  px-2 py-2 whitespace-pre-wrap">
                          STAND QTY
                        </th>
                        <th className="border text-center  px-2 py-2 whitespace-pre-wrap">
                          Address
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {productInf.all_options[0].product_option_values.map(
                        (option) => (
                          <>
                            <tr>
                              <td
                                className={`border text-center  px-2 py-2 whitespace-pre-wrap`}
                              >
                                {option.product_option_value_id}
                              </td>
                              <td
                                className={`  border text-center  px-2 py-2 whitespace-pre-wrap`}
                              >
                                {option.name === "" ? "_" : option.name}
                              </td>
                              <td
                                className={`border ${
                                  option.quantity < 5
                                    ? "text-dyellow"
                                    : "text-dgreen"
                                } text-center border-dblack px-2 py-2 whitespace-pre-wrap`}
                              >
                                {option.quantity === "" ? "_" : option.quantity}
                              </td>
                              <td
                                className={`border ${
                                  option.in_stand_quantity < 5
                                    ? "text-dyellow"
                                    : "text-dgreen"
                                } text-center border-dblack px-2 py-2 whitespace-pre-wrap`}
                              >
                                {option.in_stand_quantity === ""
                                  ? "_"
                                  : option.in_stand_quantity}
                              </td>
                              <td
                                className={`border text-center  px-2 py-2 whitespace-pre-wrap`}
                              >
                                {option.stand === "" ? "_" : option.stand}
                              </td>
                            </tr>
                          </>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              <div>
                <h2
                  id="order-history"
                  className="text-lg font-bold text-dbase1 text-left mb-1 mt-4"
                >
                  Order History:
                </h2>
                <div className="overflow-x-auto max-w-full">
                  <table className="w-full border-collapse border">
                    <thead className="bg-dgrey">
                      <tr className="bg-gray-100 border-b">
                        <th className="p-4 border-r">Date</th>
                        <th className="p-4 border-r">Status</th>
                        <th className="p-4">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productInf.statusGroupQty.order.map((order, index) => (
                        <tr key={index} className="border-b">
                          <td className="p-4 border-r">
                            {order.date_added || "_"}
                          </td>
                          <td className="p-4 border-r">
                            {order.status_group_name || "_"}
                          </td>
                          <td className="p-4">
                            {order.quantity || "_"}
                            <button
                              className="ml-2 text-blue-500"
                              onClick={() => handleOpenPopup(order.order_id)}
                            >
                              <FaEye />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Popup */}
              </div>

              <div className="mb-3">
                <h2
                  id="return-order-history"
                  className="text-lg font-bold text-dbase1 text-left mb-1 mt-4"
                >
                  Return Order History:
                </h2>
                <div className="overflow-x-auto max-w-full">
                  <table className="w-full border-collapse border">
                    <thead>
                      <tr className="bg-dgrey border-b">
                        <th className="p-2 border-r">Date</th>
                        <th className="p-2 border-r">Status</th>
                        <th className="p-2">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productInf.statusGroupQty.return &&
                      productInf.statusGroupQty.return.length > 0 ? (
                        productInf.statusGroupQty.return.map((item, index) => (
                          <tr key={index} className="border-b">
                            <td className="p-2 border-r">
                              {item.date_added || "_"}
                            </td>
                            <td className="p-2 border-r">
                              {item.status_group_name || "_"}
                            </td>
                            <td className="p-2">
                              {item.quantity || "_"}
                              <button
                                className="ml-2 text-blue-500"
                                onClick={() => handleOpenPopup(item.order_id)}
                              >
                                <FaEye />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="border-b">
                          <td className="p-2 border-r">_</td>
                          <td className="p-2 border-r">_</td>
                          <td className="p-2">_</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Popup */}
                {isPopupOpen && (
                  <div
                    className="fixed inset-0 flex items-center justify-center bg-dblack bg-opacity-50"
                    onClick={handleClosePopup}
                  >
                    <div
                      className="bg-white p-6 rounded shadow-lg"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h3 className="text-lg font-bold mb-4">Order Details</h3>
                      <div className="mb-4">
                        <strong>Order IDs:</strong>
                        <div className="mt-2">
                          {popupData
                            ? popupData.split(",").map((id, idx) => (
                                <p key={idx} className="text-sm text-gray-700">
                                  {id.trim()}
                                </p>
                              ))
                            : "_"}
                        </div>
                      </div>
                      <button
                        className="bg-dbase text-white px-4 py-2 rounded"
                        onClick={handleClosePopup}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {jardehInfo && jardehInfo?.length > 0 && (
                <div className="mb-10">
                  <h2
                    id="jardeh-history"
                    className="text-lg font-bold text-dbase1 text-left mb-1 mt-4"
                  >
                    Jardeh History:
                  </h2>
                  <div className="overflow-x-auto max-w-full">
                    <table className="w-full border-collapse border">
                      <thead>
                        <tr className="bg-dgrey border-b">
                          <th className="p-2 border-r">Jardeh ID</th>
                          <th className="p-2 border-r">Batch ID</th>
                          <th className="p-2 border-r">Product ID</th>
                          <th className="p-2 border-r">Type</th>
                          <th className="p-2 border-r">Scan Qty</th>
                          <th className="p-2  border-r">Scan Date</th>
                          <th className="p-2  border-r">Scanned By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jardehInfo?.map((item, index) => (
                          <tr key={index} className="border-b">
                            <td className="p-2 border-r">{item?.jardeh_id}</td>
                            <td className="p-2 border-r">{item?.batch_id}</td>
                            <td className="p-2 border-r">{item?.product_id}</td>
                            <td className="p-2 border-r">{item?.type}</td>
                            <td className="p-2 border-r">{item?.scan_qty}</td>
                            <td className="p-2 border-r">{item?.scan_date}</td>
                            <td className="p-2 border-r">{item?.user_name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {productInf.filters.series.length > 0 && (
                <>
                  <h2
                    id="return-order-history"
                    className="text-lg font-bold text-dbase1 text-left mb-1 mt-4"
                  >
                    Filters:
                  </h2>
                  <div className="mb-10">
                    {productInf.filters.series.map((serie, serieIndex) => (
                      <div
                        key={serieIndex}
                        style={{
                          marginBottom: "20px",
                        }}
                      >
                        {serie.group_type && (
                          <h3
                            id="return-order-history"
                            className="font-bold text-d14 text-left mb-1 mt-4 ml-2"
                          >
                            {serie.group_type}:
                          </h3>
                        )}
                        <div
                          style={{
                            maxHeight: "100%",
                            overflowY: "hidden",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {serie.products.map((item, itemIndex) => (
                            <div
                              className="bg-dbase bg-opacity-15 mb-4 py-2 px-2"
                              key={itemIndex}
                              style={{
                                display: "inline-block",
                                textAlign: "center",
                                marginRight: "10px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                                setSelectedSku(item.sku);
                                productId.current.value = item.sku;
                                setProductInf("");
                                getProducts(e);
                                searchProduct(e);
                              }}
                            >
                              <img
                                className="rounded -mt-0.5"
                                src={item.image}
                                alt={item.name}
                                style={{ maxWidth: "150px", height: "auto" }}
                              />
                              <h2
                                className=" text-d18 mt-1"
                                style={{ maxWidth: "150px", height: "auto" }}
                              >
                                {item.sku}
                              </h2>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {productInf.slaves != "" && (
                <div className="mt-3" ref={slaves}>
                  <h2 className="text-xl text-start font-semibold mb-4 text-dbase1">
                    Slaves Products
                  </h2>
                  <div className="hidden mobile:grid grid-cols-5 gap-4 max-h-[500px] overflow-y-auto pr-2">
                    {productInf?.slaves?.map((slave, index) => (
                      <div
                        key={index}
                        className="bg-white  rounded-2xl shadow-sm hover:shadow-md transition duration-200 p-4 flex flex-col gap-3"
                      >
                        {slave.image && (
                          <div className="w-full h-40 bg-gray-100 rounded-xl overflow-hidden flex items-center justify-center">
                            <img
                              src={slave.image}
                              alt={slave.name}
                              className="object-cover h-40 w-40"
                            />
                          </div>
                        )}

                        <div className="grid grid-cols-2 text-sm mt-2 text-start gap-y-1">
                          <div className="flex gap-1">
                            <span className="font-semibold">SKU:</span>
                            <p className="text-gray-700">{slave.sku}</p>
                          </div>

                          <div className="flex gap-1">
                            <span className="font-semibold">Qty:</span>
                            <p className="text-gray-700">{slave.quantity}</p>
                          </div>

                          <div className="flex gap-1">
                            <span className="font-semibold">Bin:</span>
                            <p className="text-gray-700">{slave.address}</p>
                          </div>

                          <div className="flex gap-1">
                            <span className="font-semibold">Status:</span>
                            <span
                              className={`text-sm rounded-full font-medium ${
                                slave.status === "0"
                                  ? "text-dbase"
                                  : "text-dgreen"
                              }`}
                            >
                              {slave.status === "0" ? "Disabled" : "Enabled"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="mobile:hidden grid md:grid-cols-2 lg:grid-cols-5 gap-4 max-h-[500px] overflow-y-auto pr-2">
                    {productInf?.slaves?.map((slave, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-2xl shadow-sm hover:shadow-md transition duration-200 p-4 flex gap-4 items-start"
                      >
                        {slave.image && (
                          <div className="w-32 h-32 bg-gray-100 rounded-xl overflow-hidden flex items-center justify-center flex-shrink-0">
                            <img
                              src={slave.image}
                              alt="slave"
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )}

                        <div className="flex flex-col text-sm text-start gap-y-1 mt-5 ml-5">
                          <div className="flex gap-1">
                            <span className="font-semibold">SKU:</span>
                            <p className="text-gray-700">{slave.sku}</p>
                          </div>

                          <div className="flex gap-1">
                            <span className="font-semibold">Qty:</span>
                            <p className="text-gray-700">{slave.quantity}</p>
                          </div>

                          <div className="flex gap-1">
                            <span className="font-semibold">Bin:</span>
                            <p className="text-gray-700">{slave.address}</p>
                          </div>

                          <div className="flex gap-1">
                            <span className="font-semibold">Status:</span>
                            <span
                              className={`text-sm font-medium ${
                                slave.status === "0"
                                  ? "text-dbase"
                                  : "text-dgreen"
                              }`}
                            >
                              {slave.status === "0" ? "Disabled" : "Enabled"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <MessageAlert
        message={message}
        type={showMessgErr ? "err" : "succ"}
        showMessg={showMessgErr || (showMessgSucc && true)}
      />
    </>
  );
};

export default WarehouseProduct;
